import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import FrontendLayout from "layouts/frontend";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import routes from "routes";
import { renderRoutes } from "layouts/admin";
import Auth from "views/auth/Register";
import useIdleTimeout from "hooks/useIdleTimeout";
import useAlertSessionExpiry from "hooks/userAlertSessionExpiry";
import { ForbiddenDialogProvider, useForbiddenDialog } from "hooks/ForbiddenDialogContext";
import { setForbiddenDialogCallback } from "axiosConfig";
import { getItem } from "utils/localStorage";

const AppContent = () => {
  const { showForbiddenDialog } = useForbiddenDialog();
  const location = useLocation();

  useEffect(() => {
    setForbiddenDialogCallback(showForbiddenDialog);
    return () => {
      setForbiddenDialogCallback(null);
    };
  }, [showForbiddenDialog]);

  const idleTimeoutComponent = useIdleTimeout(300000); // 5 minutes in milliseconds
  const sessionExpiryComponent = useAlertSessionExpiry();

  // Check authentication by verifying access_token in localStorage
  const isAuthenticated = !!getItem('access_token');
  // Check if current route is under admin
  const isAdminRoute = location.pathname.startsWith('/admin');
  // Only show timeout components for authenticated admin routes
  const shouldShowTimeoutComponents = isAdminRoute && isAuthenticated;

  return (
    <>
      <Routes>
        {renderRoutes(routes)}
        <Route path="auth/register" element={<Auth />} />
        <Route path="auth/*" element={<AuthLayout />} />
        <Route path="admin/*" element={<AdminLayout />} />
        <Route path="/*" element={<FrontendLayout />} />
        <Route path="/" element={<Navigate to="/home" replace />} />
      </Routes>
      {shouldShowTimeoutComponents && idleTimeoutComponent}
      {shouldShowTimeoutComponents && sessionExpiryComponent}
    </>
  );
};

const App = () => {
  return (
    <ForbiddenDialogProvider>
      <AppContent />
    </ForbiddenDialogProvider>
  );
};

export default App;